<div id="planogram-builder-builder">
  <mat-horizontal-stepper
    linear
    #mystepper
    id="planogram-stepper"
    [selectedIndex]="stepper_index"
    (selectionChange)="
      setStepperIndex($event, is_planogram_edit, edit_planogram_detail)
    "
  >
    <ng-template matStepperIcon="edit" let-index="index">
      {{ index + 1 }}
    </ng-template>

    <mat-step
      [completed]="
        planogram_base_detail_form_group.valid && screen_index_completed > 0
      "
      label="Setup Planogram"
    >
      <div class="stepper-actions-container">
        <!-- <button
          [disabled]="mode == 'edit'"
          mat-button
          (click)="handleDiscardClick(edit_planogram_detail.id)"
        >
          Discard
        </button>
        <button
          mat-button
          [disabled]="
            planogram_base_detail_form_group.invalid ||
            (planogram_name_error | async) !== ''
          "
          (click)="
            draftPlanogramDetails(is_planogram_edit, edit_planogram_detail, 0)
          "
        >
          Save as draft
        </button> -->
        <button
          class="back-button"
          (click)="handleDiscardClick(edit_planogram_detail.id, true)"
        >
          <img
            style="margin-right: 1vw; width: 1vw"
            src="../../assets/back.svg"
            alt="back"
          />Go Back
        </button>
        <button
          class="next"
          mat-raised-button
          color="warn"
          (click)="
            savePlanogramBaseDetailsAndNavigate(
              is_planogram_edit,
              edit_planogram_detail,
              0
            )
          "
          [disabled]="
            planogram_base_detail_form_group.invalid ||
            !cooler_info ||
            isSetUpScreenDisabled
          "
        >
          Next
        </button>
      </div>
      <ng-template matStepContent>
        <div id="planogram-setup-form-group-container">
          <div class="forms_npd_segment">
            <div
              style="font-size: 0.9vw"
              id="planogram-setup-form-group"
              [formGroup]="planogram_base_detail_form_group"
            >
              <div
                style="font-size: 0.9vw; font-weight: 500; margin-bottom: 2vh"
              >
                Provide data file for the relevant Unit and Channel for which
                the planogram has to be created
              </div>
              <!-- <div class="form-group">
                <label
                style="font-weight:550"
                  for="planogram_name"
                  [ngClass]="{
                    'text-danger': (planogram_name_error | async) !== ''
                  }"
                  >Planogram Name
                  <span
                    *ngIf="isRequiredField('planogram_name')"
                    class="astrick-class"
                  >
                    *</span
                  >
                </label>
                <div style="display: flex; align-items: center">
                  <input
                    type="text"
                    class="form-control"
                    id="planogramname"
                    formControlName="planogram_name"
                    placeholder="Enter Planogram Name"
                    required
                    style="min-width: 100%;font-size: 0.9vw;"
                    [ngClass]="{
                      'is-invalid': (planogram_name_error | async) !== ''
                    }"
                    (blur)="onBlurPlanogramName()"
                  />
                  <em
                    class="bi"
                    [ngClass]="{
                      'bi-check-circle text-success':
                        planogram_base_detail_form_group.get('planogram_name')
                          ?.valid && (planogram_name_error | async) === '',
                      'bi-x-circle text-danger':
                        (planogram_name_error | async) !== ''
                    }"
                    style="margin: 0 5px"
                  ></em>
                </div>

                <span
                  *ngIf="(planogram_name_error | async) !== ''"
                  class="error-message"
                >
                  {{ planogram_name_error | async }}
                </span>
                <span
                  class="error-message"
                  *ngIf="planogram_base_detail_form_group.controls['planogram_name'].errors?.['pattern']"
                >
                  <span *ngIf="planogram_name_error | async">,</span>Special
                  characters are not allowed.
                </span>
              </div> -->

              <div class="form-group dropdown">
                <label style="font-weight: 550" for="units"
                  >Unit
                  <span *ngIf="isRequiredField('units')" class="astrick-class">
                    *</span
                  >
                </label>
                <ng-template
                  #subchanneltemp
                  let-subchannellist="subchannellist"
                  [ngTemplateOutlet]="subchanneltemp"
                  [ngTemplateOutletContext]="{
                    subchannellist: units
                  }"
                >
                  <mat-select
                    class="custom-select d-block w-100"
                    placeholder="Select Unit"
                    formControlName="units"
                    disableOptionCentering
                    (selectionChange)="
                      clearSelectionOnValueChange($event, 'channel')
                    "
                  >
                    <mat-option
                      style="font-size: 0.9vw; font-weight: 500"
                      *ngFor="let unit of subchannellist"
                      [value]="unit"
                    >
                      <em
                        [ngClass]="{
                          'bi-check-circle-fill':
                            planogram_base_detail_form_group.controls['units']
                              .value === unit,
                          'bi-circle':
                            planogram_base_detail_form_group.controls['units']
                              .value !== unit
                        }"
                        class="bi"
                      ></em>
                      {{ unit }}
                    </mat-option>
                  </mat-select>
                </ng-template>
              </div>
              <div class="form-group dropdown">
                <label style="font-weight: 550" for="Channel"
                  >Channel
                  <span
                    *ngIf="isRequiredField('channel')"
                    class="astrick-class"
                  >
                    *</span
                  >
                </label>

                <mat-select
                  class="custom-select d-block w-100"
                  placeholder="Select Channel"
                  formControlName="channel"
                  disableOptionCentering
                  (selectionChange)="handleChannelChange($event)"
                  [ngClass]="{
                    'disable-dropdown':
                      !units ||
                      planogram_base_detail_form_group.controls['units'].value
                        .length == 0
                  }"
                  [attr.disabled]="
                    !planogram_base_detail_form_group.controls['units'].value
                      .length
                  "
                >
                  <mat-option
                    style="font-size: 0.9vw; font-weight: 500"
                    *ngFor="let channel of channels"
                    [value]="channel"
                  >
                    <em
                      [ngClass]="{
                        'bi-check-circle-fill':
                          planogram_base_detail_form_group.controls['channel']
                            .value === channel,
                        'bi-circle':
                          planogram_base_detail_form_group.controls['channel']
                            .value !== channel
                      }"
                      class="bi"
                    ></em>
                    {{ channel }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="form-group dropdown">
                <label style="font-weight: 550" for="cooler_type"
                  >Cooler
                  <span
                    *ngIf="isRequiredField('cooler_type')"
                    class="astrick-class"
                  >
                    *</span
                  >
                </label>

                <ng-template
                  #segmenttemp
                  let-segmentlist="segment_list"
                  [ngTemplateOutlet]="segmenttemp"
                  [ngTemplateOutletContext]="{
                    segment_list: coolers
                  }"
                >
                  <mat-select
                    class="custom-select d-block w-100"
                    placeholder="Select Cooler"
                    formControlName="cooler_type"
                    disableOptionCentering
                    [ngClass]="{
                      'disable-dropdown':
                        !channels ||
                        planogram_base_detail_form_group.controls['channel']
                          .value.length == 0
                    }"
                    [attr.disabled]="
                      !channels ||
                      planogram_base_detail_form_group.controls['channel'].value
                        .length == 0
                    "
                    value="planogram_base_detail_form_group.controls['cooler_type'].value"
                    (selectionChange)="clearSelectedCoolerInfo()"
                  >
                    <mat-option
                      style="font-size: 0.9vw; font-weight: 500"
                      *ngFor="let cooler of segmentlist"
                      [value]="cooler"
                    >
                      <em
                        [ngClass]="{
                          'bi-check-circle-fill':
                            planogram_base_detail_form_group.controls[
                              'cooler_type'
                            ].value === cooler,
                          'bi-circle':
                            planogram_base_detail_form_group.controls[
                              'cooler_type'
                            ].value !== cooler
                        }"
                        class="bi"
                      ></em>
                      {{ cooler }}
                    </mat-option>
                  </mat-select>
                </ng-template>
              </div>

              <div class="form-group dropdown">
                <label style="font-weight: 550" for="npd_selection"
                  >NPD Selection
                  <span
                    *ngIf="isRequiredField('npd_selection')"
                    class="astrick-class"
                  >
                    *</span
                  >
                </label>

                <ng-template
                  #npdSelectiontemp
                  [ngTemplateOutlet]="npdSelectiontemp"
                >
                  <mat-select
                    class="custom-select d-block w-100"
                    placeholder="Select NPD "
                    formControlName="npd_selection"
                    disableOptionCentering
                    [ngClass]="{
                      'disable-dropdown':
                        !channels ||
                        planogram_base_detail_form_group.controls['cooler_type']
                          .value.length == 0
                    }"
                    [attr.disabled]="
                      !channels ||
                      planogram_base_detail_form_group.controls['cooler_type']
                        .value.length == 0
                    "
                    value="planogram_base_detail_form_group.controls['npd_selection'].value"
                    (selectionChange)="handleNPDSelection()"
                  >
                    <mat-option
                      style="font-size: 0.9vw; font-weight: 500"
                      *ngFor="let option of npd_selections"
                      [value]="option"
                    >
                      <em
                        [ngClass]="{
                          'bi-check-circle-fill':
                            planogram_base_detail_form_group.controls[
                              'npd_selection'
                            ].value === option,
                          'bi-circle':
                            planogram_base_detail_form_group.controls[
                              'npd_selection'
                            ].value !== option
                        }"
                        class="bi"
                      ></em>
                      {{ option }}
                    </mat-option>
                  </mat-select>
                </ng-template>
              </div>

              <div style="display: flex; justify-content: flex-end">
                <button
                  [disabled]="
                    !planogram_base_detail_form_group.controls['cooler_type']
                      .value.length
                  "
                  (click)="getCoolerDetails()"
                  class="ok-button"
                >
                  Ok
                </button>
              </div>
            </div>
            <!-- <div *ngIf="temp_npd_data" class="npd_segment">
            <div class="npd_container">
              <div  *ngFor="let npd of temp_npd_data.NPDs; let i = index">
                <div class="npd_card">
                 <div *ngIf="showToolTip(npd.product_name)" [matTooltip]="npd.product_name">{{ truncateNPDName(npd.product_name) }}</div>
                 <div *ngIf="!showToolTip(npd.product_name)">{{ truncateNPDName(npd.product_name) }}</div>
                  <div class="increment_decrement_container">
                    <button
                      class="minus"
                      (click)="decrement(i, npd.product_name)"
                    >
                      -
                    </button>
                    <input
                      style="width: 3vw; height:4vh;font-size: 0.9vw;"
                      [value]="npd_data_with_facings[i].facings"
                      type="text"
                      class="input-number npd_counter_value"
                    />
                    <button
                      class="plus"
                      (click)="increment(i, npd.product_name)"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            </div>
              <div style="padding:0px 8vh">
                <div style="font-size: 0.9vw;font-weight: bold;">*NEXT button will be activated on proper selection of number of NPDs</div>
                <div style="font-weight: bold;font-size: 0.9vw;margin-top:5px;">
                  *Min. {{this.temp_npd_data.minimum_facings || this.temp_npd_data.min_facings}} facing per NPD will be allocated
                </div>
                <div style="font-size: 0.9vw;margin-top:5px;">{{npds_max_message}}</div>
              </div>
            </div>
            <div *ngIf="!temp_npd_data" class="npd_segment_skeleton">
            <div class="npd_container">
              <div *ngFor="let i of [1, 2, 3]">
                <div class="npd_card skeleton">
                  {{ " " }}
                  <div style="display: flex;">
                    <button class="minus">-</button>
                    <input
                      [disabled]="true"
                      style="width: 3vw; height:4vh;font-size: 0.9vw;"
                      type="text"
                      class="input-number npd_counter_value"
                    />
                    <button class="plus">+</button>
                  </div>
                </div>
              </div>
            </div>
              <div>
              </div>
            </div> -->
            <div style="width: 55%; position: relative; padding-left: 2.5vw">
              <div class="cooler_info_header">Cooler Info</div>
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  gap: 1vw;
                  height: 70%;
                  align-items: flex-end;
                "
              >
                <div
                  *ngIf="cooler_info && cooler_info['cooler_image_uri']"
                  style="
                    display: flex;
                    width: 50%;
                    gap: 0.5vw;
                    align-items: flex-end;
                  "
                >
                  <div
                    *ngIf="cooler_images.includes('loading')"
                    style="
                      align-self: center;
                      justify-self: center;
                      margin: auto;
                      margin-bottom: 50%;
                    "
                  >
                    <mat-spinner diameter="50"></mat-spinner>
                  </div>
                  <div *ngFor="let img of cooler_images">
                    <img
                      *ngIf="img !== 'loading'"
                      [ngStyle]="{
                        height: '35vh'
                      }"
                      style="width: 100%"
                      [src]="img"
                      alt="cooler img"
                    />
                  </div>
                </div>
                <div
                  *ngIf="
                    !cooler_info_updated ||
                    (cooler_info_updated && cooler_info_updated.length == 0)
                  "
                  style="
                    display: flex;
                    width: 50%;
                    gap: 0.5vw;
                    align-items: flex-end;
                  "
                >
                  <img
                    [ngStyle]="{
                      height: '35vh'
                    }"
                    style="width: 50%"
                    src="../../assets/12 Caser.png"
                    alt="cooler img"
                    alt="cooler img"
                  />
                </div>
                <div style="width: 100%">
                  <div>
                    <table class="caser-section">
                      <thead>
                        <tr>
                          <th></th>
                          <th
                            *ngIf="
                              cooler_info_updated &&
                              cooler_info_updated.length > 0
                            "
                          >
                            {{ cooler_info_updated[0].name }}
                          </th>
                          <th
                            *ngIf="
                              cooler_info_updated &&
                              cooler_info_updated.length > 1
                            "
                          >
                            {{ cooler_info_updated[1].name }}
                          </th>
                          <th
                            style="padding-bottom: 5.5vh"
                            *ngIf="
                              !cooler_info_updated ||
                              (cooler_info_updated &&
                                cooler_info_updated.length == 0)
                            "
                          ></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Dimensions</td>
                          <td
                            *ngIf="
                              cooler_info_updated &&
                              cooler_info_updated.length > 0
                            "
                          >
                            {{ cooler_info_updated[0].dimension }}
                          </td>
                          <td
                            *ngIf="
                              cooler_info_updated &&
                              cooler_info_updated.length > 1
                            "
                          >
                            {{ cooler_info_updated[1].dimension }}
                          </td>
                          <td
                            style="padding-bottom: 5.5vh"
                            *ngIf="
                              !cooler_info_updated ||
                              (cooler_info_updated &&
                                cooler_info_updated.length == 0)
                            "
                          ></td>
                        </tr>
                        <tr>
                          <td>Shelves</td>
                          <td
                            *ngIf="
                              cooler_info_updated &&
                              cooler_info_updated.length > 0
                            "
                          >
                            {{ cooler_info_updated[0].shelf }}
                          </td>
                          <td
                            *ngIf="
                              cooler_info_updated &&
                              cooler_info_updated.length > 1
                            "
                          >
                            {{ cooler_info_updated[1].shelf }}
                          </td>
                          <td
                            style="padding-bottom: 5.5vh"
                            *ngIf="
                              !cooler_info_updated ||
                              (cooler_info_updated &&
                                cooler_info_updated.length == 0)
                            "
                          ></td>
                        </tr>
                        <tr>
                          <td>Product Facings</td>
                          <td
                            *ngIf="
                              cooler_info_updated &&
                              cooler_info_updated.length > 0
                            "
                          >
                            {{ cooler_info_updated[0].product_facings }}
                          </td>
                          <td
                            *ngIf="
                              cooler_info_updated &&
                              cooler_info_updated.length > 1
                            "
                          >
                            {{ cooler_info_updated[1].product_facings }}
                          </td>
                          <td
                            style="padding-bottom: 5.5vh"
                            *ngIf="
                              !cooler_info_updated ||
                              (cooler_info_updated &&
                                cooler_info_updated.length == 0)
                            "
                          ></td>
                        </tr>
                        <tr>
                          <td>Shelf Config</td>
                          <td
                            *ngIf="
                              cooler_info_updated &&
                              cooler_info_updated.length > 0
                            "
                          >
                            <div
                              *ngFor="
                                let config of displayCoolerShelfConfig(
                                  cooler_info_updated[0]['shelf_config']
                                )
                              "
                            >
                              <div>
                                {{ config }}:
                                {{
                                  cooler_info_updated[0]["shelf_config"][config]
                                }}
                              </div>
                            </div>
                          </td>
                          <td
                            *ngIf="
                              cooler_info_updated &&
                              cooler_info_updated.length > 1
                            "
                          >
                            <div
                              *ngFor="
                                let config of displayCoolerShelfConfig(
                                  cooler_info_updated[1]['shelf_config']
                                )
                              "
                            >
                              <div>
                                {{ config }}:
                                {{
                                  cooler_info_updated[1]["shelf_config"][config]
                                }}
                              </div>
                            </div>
                          </td>
                          <td
                            style="padding-bottom: 5.5vh"
                            *ngIf="
                              !cooler_info_updated ||
                              (cooler_info_updated &&
                                cooler_info_updated.length == 0)
                            "
                          ></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- <div *ngIf="!cooler_info || !cooler_info['cooler_image_uri']" style="display: flex;flex-direction: row;gap:3vw">
                 <img  style="height:60vh;" src="../../assets/dummy_cooler.png" alt="cooler img"/>
                 <div style="width:100%">
                  <div class="cooler_info_header">Cooler Info</div>
                  <div>
                    <table class="cooler_info">
                     <thead>
                      <tr>
                        <th></th>
                        <th></th>
                      </tr>
                     </thead>
                     <tbody>
                      <tr>
                        <td>Name:</td>
                        <td class="label-value" *ngIf="cooler_info"></td>
                      </tr>
                      <tr>
                        <td>Dimensions:</td>
                        <td class="label-value" *ngIf="cooler_info">
                        </td>
                      </tr>
                      <tr>
                        <td>Shelves:</td>
                        <td class="label-value" *ngIf="cooler_info"></td>
                      </tr>
                      <tr>
                        <td>Product Facings:</td>
                        <td class="label-value" *ngIf="cooler_info"></td>
                      </tr>
                      <tr>
                        <td>Shelf Config:</td>
                        <td class="label-value" *ngIf="cooler_info">
                        </td>
                      </tr>
                     </tbody>
                    </table>
                  </div>
                 </div>
              </div> -->
              <div
                class="disabled_cooler_info"
                *ngIf="!cooler_info || !cooler_info['cooler_image_uri']"
              ></div>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-step>
    <mat-step [completed]="npds_data_valid" label="Guidelines Input">
      <div class="stepper-actions-container">
        <button
          class="back-button"
          (click)="handleDiscardClick(edit_planogram_detail.id, true)"
        >
          <img
            style="margin-right: 1vw; width: 1vw"
            src="../../assets/back.svg"
            alt="back"
          />Go Back
        </button>
        <button
          mat-raised-button
          class="next"
          color="warn"
          [disabled]="!npds_data_valid"
          (click)="
            savePlanogramBaseDetailsAndNavigate(
              is_planogram_edit,
              edit_planogram_detail,
              1
            )
          "
        >
          Next
        </button>
      </div>
      <ng-template matStepContent>
        <app-guidelines-input
          (checkNpdsValidationInGuidelines)="
            checkNpdsValidationInGuidelines($event)
          "
          [is_display]="true"
        >
        </app-guidelines-input>
      </ng-template>
    </mat-step>
    <!-- <mat-step
      [completed]="cooler_template_form_group.valid"
      label=""
      [stepControl]="cooler_template_form_group"
    >
      <div class="stepper-actions-container">
        <button
          mat-button
          [disabled]="mode == 'edit'"
          (click)="handleDiscardClick(edit_planogram_detail.id)"
        >
          Discard
        </button>
        <button
          mat-button
          [disabled]="cooler_template_form_group.invalid || create_new_template"
          (click)="
            draftPlanogramDetails(is_planogram_edit, edit_planogram_detail, 1)
          "
        >
          Save as draft
        </button>
        <button
          mat-raised-button
          color="warn"
          [disabled]="cooler_template_form_group.invalid || create_new_template"
          (click)="
            savePlanogramBaseDetailsAndNavigate(
              is_planogram_edit,
              edit_planogram_detail,
              1
            )
          "
        >
          Next
        </button>
      </div>
      <ng-template matStepContent>
        <em
          *ngIf="!create_new_template"
          class="bi bi-arrow-left back-icon"
          (click)="goToPreviousStep(0); mystepper.previous()"
        ></em>
        <div id="cooler-template-container" *ngIf="stepper_index === 1">
          <div
            *ngIf="create_new_template; then thenBlock; else elseBlock"
          ></div>
          <ng-template #thenBlock>
            <app-cooler-template-creator
              (newTemplateCreateBackEvent)="templateCreateBackEvent($event)"
              (newTemplateCreateBackAndNextScreenNavigateEvent)="
                templateCreateBackAndNextScreenNavigateEventHandle($event)
              "
              [planogram_id]="edit_planogram_detail.id"
              [edit_template_id]="edit_template_id"
            ></app-cooler-template-creator>
          </ng-template>
          <ng-template #elseBlock>
            <div style="display: flex; height: 100%; width: 100%">
              <div style="min-height: 100%; width: 70%; padding-right: 10px">
                <h3>
                  Create a cooler template or select from the existing templates
                </h3>
                <button
                  id="create-new-template-btn"
                  mat-raised-button
                  color="warn"
                  (click)="handleCreateNewTemplateBtnClick()"
                >
                  Create New Template
                </button>
                <div id="existing-cooler-template-container">
                  <mat-form-field
                    appearance="fill"
                    class="template-search-input"
                  >
                    <input
                      matInput
                      [(ngModel)]="cooler_template_search_input"
                      type="text"
                      placeholder="Select"
                    />
                    <mat-icon>search</mat-icon>
                  </mat-form-field>

                  <div
                    id="templates-container"
                    [formGroup]="cooler_template_form_group"
                    *ngIf="cooler_template_form_group.get('cooler_template')"
                  >
                    <mat-card
                      class="template-mat-card"
                      [ngClass]="{
                        'selected-border':
                          cooler_template_form_group.controls['cooler_template']
                            .value === template.id
                      }"
                      *ngFor="
                        let template of sortTemplates(saved_templates)
                          | sortAndFilter
                            : cooler_template_search_input.trim().toLowerCase()
                            : 'name'
                            : 'created_date'
                      "
                    >
                      <mat-card-title-group>
                        <mat-card-title>
                          <mat-checkbox
                            class="cooler-template-checkbox"
                            color="warn"
                            [value]="template.id"
                            [checked]="
                              cooler_template_form_group.controls[
                                'cooler_template'
                              ].value === template.id
                            "
                            (change)="handleCoolerCheckbox($event)"
                          >
                            <img
                              [src]="template.img_link + sas"
                              style="width: 24px"
                              alt=""
                            />
                            {{ template.name }}
                            <span
                              *ngIf="template.door"
                              style="float: right; margin-right: 50px"
                            >
                              ( {{ template.door || 1 }} Door Cooler )
                            </span>
                          </mat-checkbox>
                        </mat-card-title>
                        <em
                          class="bi bi-pencil"
                          [ngStyle]="{ cursor: 'pointer' }"
                          [ngClass]="{
                            'selected-text':
                              cooler_template_form_group.controls[
                                'cooler_template'
                              ].value === template.id
                          }"
                          (click)="editTemplate(template)"
                        ></em>
                      </mat-card-title-group>
                    </mat-card>
                  </div>
                </div>
              </div>

              <div
                *ngIf="cooler_template_form_group.valid"
                id="picos-sku-list-container"
              >
                <div
                  style="
                    width: calc(100% + 30px);
                    height: calc(100%);
                    overflow: auto;
                  "
                >
                  <h3>PicOs based Recommended SKUs</h3>
                  <mat-list id="sku-list">
                    <mat-list-item
                      class="no-padding"
                      *ngFor="let sku of picos_sku_list"
                    >
                      <img
                        mat-list-icon
                        [src]="sku.sku_img_link + sas"
                        alt="..."
                        class="static-sku-dimension"
                        [ngStyle]="{
                          'height.px':
                            (sku.sku_height * CONFIG.MMTOPIXCEL) /
                            CONFIG.HEIGHTCONSTANT,
                          'width.px':
                            (sku.sku_diameter_length * CONFIG.MMTOPIXCEL) /
                            CONFIG.WIDTHCONSTANT,
                          'border-radius': 0
                        }"
                      />
                      <h3 mat-line>{{ sku.sku_name }}</h3>
                      <p mat-line>
                        <span> {{ sku.sku_volume }}ml </span>
                      </p>
                    </mat-list-item>
                  </mat-list>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </ng-template>
    </mat-step> -->

    <mat-step [completed]="false" label="Review Planogram">
      <div class="stepper-actions-container">
        <!-- <button
          mat-button
          [disabled]="mode == 'edit'"
          (click)="handleDiscardClick(edit_planogram_detail.id)"
        >
          Discard
        </button>
        <button
          mat-button
          (click)="
            draftPlanogramDetails(is_planogram_edit, edit_planogram_detail, 2)
          "
        >
          Save as draft
        </button> -->
        <button
          mat-raised-button
          color="warn"
          (click)="
            savePlanogramBaseDetailsAndNavigate(
              is_planogram_edit,
              edit_planogram_detail,
              2
            )
          "
        >
          SAVE & EXIT
        </button>
      </div>
      <ng-template matStepContent>
        <app-planogram-new-builder
          [isReset]="isReset"
          [is_display]="true"
          [planogram_id]="edit_planogram_detail.id"
          (resetSkusInPlanogram)="resetPlanogram($event)"
          [planogram_details]="{
            channel: planogram_base_detail_form_group.get('channel')?.value,
            unit: planogram_base_detail_form_group.get('units')?.value,
            cooler: planogram_base_detail_form_group.get('cooler_type')?.value
          }"
        ></app-planogram-new-builder>
      </ng-template>
    </mat-step>
    <!-- <mat-step
      [completed]="planogram_status === CONFIG.PLANOGRAMSTATUS.ACTIVE"
      label="Publish"
    >
      <div class="stepper-actions-container">
        <button
          mat-button
          [disabled]="mode == 'edit'"
          (click)="handleDiscardClick(edit_planogram_detail.id)"
        >
          Discard
        </button>
        <button
          mat-button
          (click)="
            draftPlanogramDetails(is_planogram_edit, edit_planogram_detail, 3)
          "
        >
          Save as draft
        </button>
        <button
          mat-raised-button
          color="warn"
          (click)="
            savePlanogramBaseDetailsAndNavigate(
              is_planogram_edit,
              edit_planogram_detail,
              3            )
          "
        >
          Publish
        </button>
      </div>
      <ng-template matStepContent>
        <app-publish-planogram
          [is_display]="stepper_index === 3"
          [planogram_id]="edit_planogram_detail.id"
          [planogram_detail]="edit_planogram_detail"
          (goToPreviousStepEventEmitter)="
            goToPreviousStep($event); mystepper.previous()
          "
        ></app-publish-planogram>
      </ng-template>
    </mat-step> -->
  </mat-horizontal-stepper>
  <app-loader [is_show_loader]="(is_show_loader | async)!"></app-loader>
</div>
